<template>
    <main>
       <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                     <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                     </div>
                     <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Edit Email Template</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
        <CustomEdit v-else></CustomEdit>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/EmailTemplates/MenuList.vue";
    import lang from "@/views/modules/EmailTemplates/language/en";
    import GenericEdit from "@/components/layout/shared/generic/EditView.vue";
    import CustomEdit from "@/views/modules/EmailTemplates/EditView.vue";

    export default {
        name: "new-email-template",
        components: {
            breadcrumbs,
            GenericEdit,
            CustomEdit,
        },
        data() {
            return {
                generic: false,
                metaList: [
                    {
                        type: 'text',
                        name: 'name',
                        label: lang.LBL_BUDGETHEAD_NAME,
                        required: true
                    },
                    {
                        type: 'text',
                        name: 'template_text',
                        label: lang.LBL_BUDGETHEAD_SEQUENCE,
                        required: true
                    },
                    {
                        type: 'selectbox',
                        name: 'status',
                        label: lang.LBL_STATUS,
                        required: false,
                        items: [
                            { value: 'Active' },
                            { value: 'Inactive' },
                        ],
                    },
                   
                ],

                urls: 'api/modules/emailtemplates',

                routePath: {
                    path: 'emailtemplates',
                    detail: false
                }
            }
        },
        mounted() {
            this.childMethod()
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
            }
        },
    }
</script>